<template>
  <b-modal ref="modal" size="lg">
    <div slot="modal-header" class="d-flex w-100">
      <span class="modal-title mx-auto h4">Setup MessageBird</span>
      <button type="button" class="close ml-0" @click="hide" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <!-- using b-* elements here since plain bootstrap collapse/accordion apparently doesn't work within b-modal -->
    <div role="tablist" class="accordion">

      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-btn href="#" v-b-toggle.accordion1 variant="link" class="d-inline-flex w-100 justify-content-between">
            1. Status Notification
            <icon class="when-opened" name="chevron-down" flip="vertical"></icon>
            <icon class="when-closed" name="chevron-down"></icon>
          </b-btn>
        </b-card-header>
        <b-collapse id="accordion1" visible accordion="setup-accordion" role="tabpanel">
          <b-card-body class="px-4">
            <p class="card-text">In order to receive delivery notifications, you have to set Amio Webhook URL in
              <a href="https://dashboard.messagebird.com/en/developers/settings" target="_blank">MessageBird developers page</a>. Copy Webhook
              URL shown below and paste it to <strong>STATUS REPORTS URL</strong> in MessageBird administration.
              See <a href="https://docs.amio.io/docs/mobile-messagebird#section-set-messagebird-status-url" target="_blank">documentation</a> for more details.
            </p>
            <div class="row">
              <label for="modal-status-webhook-url" class="col-4 my-auto">Status Webhook URL:</label>
              <input id="modal-status-webhook-url" ref="modal-status-webhook-url" class="form-control col-6" readonly :value="statusWebhookUrl"/>
              <copy-button :value="statusWebhookUrl" :title="'Copy'" @onSuccess="onCopyStatus" class="col-2 my-auto"/>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-btn href="#" v-b-toggle.accordion2 variant="link" class="d-inline-flex w-100 justify-content-between">
            2. Receive SMS (optional)
            <icon class="when-opened" name="chevron-down" flip="vertical"></icon>
            <icon class="when-closed" name="chevron-down"></icon>
          </b-btn>
        </b-card-header>
        <b-collapse id="accordion2" accordion="setup-accordion" role="tabpanel">
          <b-card-body class="px-4 card-scrollable">
            <p class="card-text">
              If you want to receive incoming SMS in this channel, you have to set up forwarding to Amio in MessageBird administration.
              Thanks to MessageBird's Flow Builder feature, this will only take a few clicks.
            </p>
            <div class="row mb-4">
              <label for="modal-receive-webhook-url" class="col-4 my-auto">Receive Webhook URL:</label>
              <input id="modal-receive-webhook-url" ref="modal-receive-webhook-url" class="form-control col-6" readonly :value="receiveWebhookUrl"/>
              <copy-button :value="receiveWebhookUrl" :title="'Copy'" @onSuccess="onCopyReceive" class="col-2 my-auto"/>
            </div>
            <ol class="card-text">
              <li>Go to <a href="https://dashboard.messagebird.com/en/flow-builder" target="_blank">Flow Builder</a> in MessageBird administration.</li>
              <li>Use a template called "Call HTTP endpoint with SMS" to create a new Flow.</li>
              <li>
                In the Flow, click the SMS node, select MessageBird number(s) that should forward received SMS to this Amio channel, and click "Save".
                <div class="d-flex justify-content-center">
                  <img class="my-2" src="../../../../assets/img/messagebird_setup/flow1.png"/>
                </div>
              </li>
              <li>
                Click the Forward to URL node, select "POST" Method and copy your Receive Webhook URL (above) to the URL field
                in the Flow. Click "Save" to save the changes.
                <div class="d-flex justify-content-center">
                  <img class="my-2" src="../../../../assets/img/messagebird_setup/flow2.png"/>
                </div>
              </li>
              <li>Click "Publish" button in the top right corner to save your Flow and make it active.</li>
            </ol>

            <div class="alert alert-warning" role="alert">
              <h5 class="alert-heading">Having trouble?</h5>
              <p>See <a href="https://docs.amio.io/docs/mobile-messagebird#section-set-messagebird-receive-url" target="_blank">documentation</a> for more detailed instructions.</p>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>

    <div slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click="hide">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import CopyButton from '@/components/common/CopyButton'
  import 'vue-awesome/icons/chevron-down'

  export default {
    components: {
      CopyButton
    },

    props: {
      statusWebhookUrl: {
        type: String,
        required: true
      },
      receiveWebhookUrl: {
        type: String,
        required: true
      }
    },

    methods: {
      show() {
        this.$refs.modal.show()
      },
      hide() {
        this.$refs.modal.hide()
      },
      onCopyStatus() {
        this._onCopy('modal-status-webhook-url')
      },
      onCopyReceive() {
        this._onCopy('modal-receive-webhook-url')
      },
      _onCopy(refName) {
        const ref = this.$refs[refName]
        ref.focus()
        ref.select()
      }
    }
  }
</script>

<style>
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
</style>
